<template>
  <div>
    <app-overlay-loader v-if="preloader" />

    <div class="row">
      <div class="col-12">
        <legend>
          <p class="text-primary">Documentación anterior</p>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 25%"
              >
                USUARIO
              </th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="accApp && accApp.request_signed">
              <td class="align-middle">Solicitud de Acreditación</td>
              <td class="align-middle text-center">
                {{
                  accApp.request_signed.user
                    ? `${accApp.request_signed.user.first_name} ${accApp.request_signed.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ accApp.request_signed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(accApp, 'request_signed')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="accApp.request_signed">
              <td class="align-middle">
                Anexos de la Solicitud de Acreditación
              </td>
              <td class="align-middle text-center">
                {{
                  accApp.user
                    ? `${accApp.user.first_name} ${accApp.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ accApp.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                  class="btn btn-success"
                  :href="`/accreditations/applications/${accApp.id}?tab=Anexos`"
                  target="_blank"
                  ><app-icon name="file" /> {{ $t("view") }}</a
                >
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.file_evaluation">
              <td class="align-middle">Propuesta del Equipo Evaluador</td>
              <td class="align-middle text-center">
                {{
                  evalTest.file_evaluation.user
                    ? `${evalTest.file_evaluation.user.first_name} ${evalTest.file_evaluation.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.file_evaluation_date | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'file_evaluation')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-sm-12">
        <legend>
          <p class="text-primary">Equipo Evaluador</p>
        </legend>
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center" style="width: 20%">Tipo</th>
              <th scope="col">Nombre</th>
              <th scope="col" class="text-center" style="width: 20%">
                Designación Aceptada
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in evalTest.evaluation_team" :key="'e' + i">
              <td class="text-center" style="width: 20%">
                {{ v.evaluator_type.value }}
              </td>
              <td>{{ v.evaluator.first_name }} {{ v.evaluator.last_name }}</td>
              <td class="text-center" style="width: 20%">
                <span
                  class="badge badge-sm badge-pill badge-warning"
                  v-if="v.is_confirmed == null"
                  >Pendiente</span
                >
                <span
                  class="badge badge-sm badge-pill badge-success"
                  v-if="v.is_confirmed == 1"
                  >Aceptado</span
                >
                <span
                  class="badge badge-sm badge-pill badge-success"
                  v-if="v.is_confirmed == 0"
                  >No Aceptado</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!--Mostrar unicamente si es EVALUACION de tipo Inspeccion o Certificacion-->
      <div class="col-sm-12" v-if="showInputFile">
        <form
          ref="form"
          data-url="/accreditationtechnical/evaluationTeamDesignation/designationReport/update"
          :class="{ 'loading-opacity': preloader }"
          enctype="multipart/form-data"
        >
          <legend>
            <p class="text-primary">Borrador del plan de evaluación</p>
          </legend>
          <div class="col-6">
            <div class="form-group">
              <app-input
                type="file"
                :label="
                  inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')
                "
                v-model="inputs.file_2"
                v-if="!inputs.standard_evaluate"
              />
              <div class="mt-2">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'standard_evaluate')"
                  v-if="inputs.standard_evaluate"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="openDeleteModal('standard_evaluate')"
                  v-if="inputs.standard_evaluate"
                >
                  <app-icon name="trash-2" />
                  {{ $t("delete") }}
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-3">
              <button
                type="submit"
                class="btn btn-primary mr-2"
                v-if="!inputs.standard_evaluate"
                @click.prevent="submit"
              >
                {{ $t("save") }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <app-confirmation-modal
        v-if="deleteModal"
        modal-id="delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea eliminar este archivo?"
      />
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../apiUrl";
import {
  axiosGet,
  axiosPost,
} from "../../../../../../../../resources/js/app/helpers/AxiosHelper";
export default {
  mixins: [FormMixin],

  data() {
    return {
      preloader: false,
      inputs: {},
      lider: [],
      evaluators: [],
      showRiskMatrix: false,
      showInputFile: false,
      deleteModal: false,
      selected: "",
    };
  },
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },
    accApp() {
      return this.evalTest ? this.evalTest.accreditation_applications : {};
    },
  },
  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  created() {
    this.loadForm();
  },
  methods: {
    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
    submit() {
      this.preloader = true;
      let formData = new FormData();
      formData.append(
        "eval_test_id",
        this.$store.state.evaluatorReview.evalTestId
      );
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },
    afterSuccess({ data: { data } }) {
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
      this.loadForm();
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    loadForm() {
      const url = `${actions.TECHNICAL_ANALYSIS_REPORT}/evaluationTeamDesignation/designationReport/show/${this.$store.state.evaluatorReview.evalTestId}`;
      axiosGet(url)
        .then((res) => {
        
          this.inputs = res.data;
          var type = res.data.type;
          var area =
            res.data.accreditation_applications.accreditation_area.name;
          // Verificar si se muestra la seccion "Puntos de la norma a evaluar" si todos los evaluadoes estan aceptados.
          var countEvaluationTeam = res.data.evaluation_team.length;
          var isActiveRows = 0;

          for (let i = 0; i < countEvaluationTeam; i++) {
            if (res.data.evaluation_team[i].is_confirmed) {
              isActiveRows = isActiveRows + 1;
            }
          }
          if (isActiveRows >= countEvaluationTeam) {
            // Las evaluaciones estan aprovadas por los evaluadores.
            if (type == "E") {
              this.showRiskMatrix = true;
            }
            // Verificar si la solicitud es de Inspeccion o Certificado :: mostrar el input file.
            if (
              (area == "INSPECCIÓN" && res.data.type == "E") ||
              (area == "CERTIFICACIÓN" && res.data.type == "E")
            ) {
              this.showInputFile = true;
            }
          }
        })
        .catch(({ error }) => {});
    },
    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },
    confirmed() {
      this.inputs[this.selected] = null;
      this.submit();
    },

    cancelled() {
      this.deleteModal = false;
    },
  },
};
</script>
